export default (path) => `${process.env.PUBLIC_URL}${path}`;
